import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export class IsEqualWith extends Validators {
  static validate(compareControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      let result: any = { valuesNotMatch: { value: control.value } };
      let valid = false;

      try {
        if (compareControl instanceof Array) {
          compareControl.forEach(
            (controlForCompare: AbstractControl) =>
              (valid = valid && IsEqualWith.compareValues(control, controlForCompare)),
          );
        } else if (compareControl instanceof AbstractControl) {
          valid = IsEqualWith.compareValues(control, compareControl);
        }

        if (valid) {
          result = null;
        }
      } catch (err) {
        result = err;
      }

      return result;
    };
  }

  /**
   * @param {AbstractControl} control
   * @param {AbstractControl} controlForCompare
   * @returns {boolean}
   */
  private static compareValues(control: AbstractControl, controlForCompare: AbstractControl): boolean {
    return control.value === controlForCompare.value;
  }
}
